import action from './action';

const Component = () => import('./Aisle');

export { Component, action };
